// @flow
import RemindAPI from 'lib/RemindAPI';
import GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG from 'admin/components/AdminAutoMessageSftpCredentials/queries/AdminAutoMessageSftpCredentialsQuery.gql';
import EDIT_SFTP_CREDS_MUTATION from 'admin/components/AdminAutoMessageSftpCredentialsModal/queries/EditSftpCredentialsMutation.gql';
import GENERATE_SFTP_CREDS_MUTATION from 'admin/components/AdminAutoMessageSftpCredentialsModal/queries/GenerateSftpCredentialsMutation.gql';
import REVOKE_SFTP_CREDS_MUTATION from 'admin/components/AdminAutoMessageSftpCredentialsModal/queries/RevokeSftpCredentialsMutation.gql';
import ToastActions from 'actions/ToastActions';

function handleGQLError(error: errorFragmentFragment, consoleErrorText: string) {
  console.warn(error);
  console.error(consoleErrorText);
  ToastActions.showErrorToast('Oops, looks like something went wrong');
}

export function generateAutoMessageSftpCredentials(
  displayName: string,
  orgUuid: string,
  onChange?: (*) => void
) {
  RemindAPI.execute({
    mutation: GENERATE_SFTP_CREDS_MUTATION,
    variables: {
      input: {
        displayName,
        orgUuid,
        featureName: 'AutoMessaging',
      },
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG,
        variables: { orgUuid },
      },
    ],
  }).then(
    res => {
      const { error, sftpCredentials } = res.generateSftpFeatureCredentials;
      if (error) {
        handleGQLError(error, 'generateAutoMessageSftpCredentials failure');
        return;
      }
      if (onChange) {
        onChange(sftpCredentials);
      }
      ToastActions.showSuccessToast('Credentials successfully generated');
    },
    err => {
      handleGQLError(err, 'generateAutoMessageSftpCredentials failure');
    }
  );
}

export function editAutoMessageSftpCredentials(
  displayName: string,
  username: string,
  orgUuid: string,
  onChange?: () => void
) {
  RemindAPI.execute({
    mutation: EDIT_SFTP_CREDS_MUTATION,
    variables: {
      input: {
        username,
        displayName,
        orgUuid,
        featureName: 'AutoMessaging',
      },
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG,
        variables: { orgUuid },
      },
    ],
  }).then(
    res => {
      const { error } = res.editSftpFeatureCredentials;
      if (error) {
        handleGQLError(error, 'editAutoMessageSftpCredentials failure');
        return;
      }
      if (onChange) {
        onChange();
      }
      ToastActions.showSuccessToast('Name successfully changed');
    },
    err => {
      handleGQLError(err, 'editAutoMessageSftpCredentials failure');
    }
  );
}

export function revokeAutoMessageSftpCredentials(
  username: string,
  orgUuid: string,
  onChange?: () => void
) {
  RemindAPI.execute({
    mutation: REVOKE_SFTP_CREDS_MUTATION,
    variables: {
      input: {
        username,
        orgUuid,
      },
    },
    refetchQueries: [
      {
        query: GET_AUTO_MESSAGE_SFTP_CREDENTIALS_FOR_ORG,
        variables: { orgUuid },
      },
    ],
  }).then(
    res => {
      const { error } = res.revokeSftpFeatureCredentials;
      if (error) {
        handleGQLError(error, 'revokeAutoMessageSftpCredentials failure');
        return;
      }
      if (onChange) {
        onChange();
      }
      ToastActions.showSuccessToast('Credentials successfully revoked');
    },
    err => {
      handleGQLError(err, 'revokeAutoMessageSftpCredentials failure');
    }
  );
}
